import './App.css'
import { Routes, Route } from "react-router-dom"
import { useEffect } from 'react'
import Header from "./header/Header.jsx"
import Home from "./Home/Home.jsx"
import Map from "./Map/Map"
import About from "./Home/About.jsx"
import Team from "./Home/Team.jsx"
import Publications from "./Home/Publications.jsx"
import Resources from "./Home/Resources.jsx"

function App() {
  useEffect(() => {
    document.title = "SSHM4Dams"
  }, [])
  return (
    <>
      <Header className='header' />
      <Routes /* className='routes' */>
        <Route path="/" element={<Home />}></Route>
        <Route path="/about" element={<About />}></Route>
        <Route path="/team" element={<Team />}></Route>
        <Route path="/map" element={<Map />}></Route>
        <Route path="/publications" element={<Publications />}></Route>
        <Route path="/data-sharing" element={<Resources />}></Route>
      </Routes>
    </>
  )
}

export default App
